// The shared mailbox meeting emails are sent from (spec D1, §4.6). Graph can't find this mailbox
// by its @sawtoothadvisors.io address (its sign-in name is on another domain), so sends address it
// by object id and set `from` to the public address.
export const SHARED_MAILBOX = {
  address: "updates@sawtoothadvisors.io",
  graphId: "851cb7c1-5e19-4f11-af05-d7d6c65dfed8",
  name: "Client Updates",
};
